<template>
  <div id="sac-table-search-container">
    <input
      v-if="position !== 'right'"
      ref="sac-ts-input"
      v-model="searchValue"
      :class="[
        search.length > 0 ? 'active' : '',
        'sac-ts-input',
      ]"
      placeholder="Search"
    >
    <button
      ref="sac-ts-button"
      type="button"
      class="sac-ts-button"
      @click="handleInput()"
    >
      <img
        v-if="search.length > 0"
        :class="['clear-icon', darkMode ? 'white-icon' : '']"
        src="@shared/assets/img/table/x.png"
        alt="clear"
      >
      <img
        v-else
        :class="['search-icon', darkMode ? 'white-icon' : '']"
        src="@shared/assets/img/table/search.png"
        alt="search"
      >
    </button>
    <input
      v-if="position === 'right'"
      ref="sac-ts-input"
      v-model="searchValue"
      :class="[
        search.length > 0 ? 'active' : '',
        'sac-ts-input',
      ]"
      placeholder="Search"
    >
  </div>
</template>

<script>
export default {
  name: 'SACTableSearch',
  props: {
    search: {
      type: String,
      required: true,
    },
    position: String,
    darkMode: Boolean,
  },
  data() {
    return {
      searchValue: this.search,
    };
  },
  watch: {
    searchValue() {
      this.$emit('input', this.searchValue);
    },
  },
  methods: {
    handleInput() {
      if (this.search.length > 0) {
        this.$emit('input', '');
        this.searchValue = '';
        if (this.$refs['sac-ts-button']) {
          this.$refs['sac-ts-button'].blur();
        }
      } else if (this.$refs['sac-ts-input']) {
        this.$refs['sac-ts-input'].focus();
      }
    },
  },
};
</script>

<style lang="scss">

#sac-table-search-container {
  display: flex;
  align-items: center;

  .sac-ts-input {
    height: 34px;
    width: 0;
    background-color: $N5;
    border-radius: 4px;
    transition: width ease .2s;

    &:focus {
      width: 250px;
      padding-left: 12px;
      box-shadow: 0 0 3px 4px rgba(9, 15, 32, 0.02);
    }

    &.active {
      width: 250px;
      padding-left: 12px;
      box-shadow: 0 0 3px 4px rgba(9, 15, 32, 0.02);
    }
  }

  .sac-ts-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 4px;

    .search-icon {
      width: 17px;
      height: 17px;
    }

    .white-icon {
      filter: invert(100%);
    }

    &:hover {
      background-color: $N10;
    }

    &:focus {
      background-color: $N20;
    }
  }
}
</style>
